import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentCycleCountSummaryComponent } from './equipment-cycle-count-summary.component';
import { CenteredMessageModule } from '../centered-message/centered-message.module';

import { MatTabsModule } from '@angular/material/tabs';
import { LoadingSpinnerModule } from '../loading-spinner/loading-spinner.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { MaterialModule } from 'projects/desktop/src/app/_other-modules/material.module';
import { TacticalNavigationModule } from '../tactical-navigation/tactical-navigation.module';
import { ChartTypeSliderModule } from '../chart-type-slider/chart-type-slider.module';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { NgxResize } from 'ngxtension/resize';

@NgModule({
  declarations: [
    EquipmentCycleCountSummaryComponent
  ],
  imports: [
    CommonModule,
    CenteredMessageModule,
	NgxResize,
    MatTabsModule,
    LoadingSpinnerModule,
    MatTooltipModule,
    ChartsModule,
	MaterialModule,
	TacticalNavigationModule,
	ChartTypeSliderModule,
	TourMatMenuModule,
  ],
  exports: [EquipmentCycleCountSummaryComponent]
})
export class EquipmentCycleCountSummaryModule { }
